module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("2. PRESUPPOSITIONS IN READING AND UNDERSTANDING")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("The historical shift in presuppositions")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For the purposes of this discussion I will use the term ‘presupposition’ as defined by John Frame:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("A presupposition is a belief that takes precedence over another and therefore serves as a criterion for another. An ultimate presupposition is a belief over which no other takes precedence.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN22",
      "id": "ap_NFIN22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Every thinker and observer makes unprovable assumptions about reality. It is the claim of Christian theism that non-Christian world-views make unsustainable assumptions. Empiricism, for example, depends on certain presuppositions that are not arrived at empirically. Thus it can never get to ultimate truth by purely empirical means. There was a time when Western thought was not totally driven by rationalist empiricism, but accepted divine revelation in Scripture as the absolute norm. There were various distortions of this, but it remained the foundational belief in the understanding "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("of reality. The divine Author was the defining point both as to the nature of the communication and as to the ability of author and reader/hearer to make sense of the communication. Historic Christianity made assumptions based on the conviction that Scripture conveyed the truth about God, mankind and the world. In other words, the biblical doctrines of creation and the lordship of God over time and space meant that he who created all things, and who governs all things, alone could interpret all things.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("The Enlightenment led to different assumptions. Over a period of time, the natural universe came to be seen as the ultimate reality; God came to be viewed as part of this general reality and as thoroughly immanent. It was, then, a short step to regarding God as irrelevant or even non-existent. Human beings were the summit of natural processes, and human reason autonomous. Thus the theological dimension in hermeneutics, even when dealing with theological texts, was eventually either ignored or ruled out as impossible and irrelevant. The modern result of this change is the set of presuppositions that include:")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("the supremacy of humanity and the autonomy of human reason;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("scientific method (reason plus empirical input from our senses) as the only valid way to the truth.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Modernism continued to acknowledge the author, but only the human author, as having a major role in the creation of meaning in the biblical text. In time, the emphasis shifted from the communicator (the emphasis of historical-critical method) to the communication itself (the emphasis of the new literary critical methods). Postmodernism is generally seen as having moved beyond the presuppositions of modernism, although there is still much discussion whether or not this is really so. There are some significant changes of perspective, however, which affect the way people perceive reality. Postmodernism presses further with the autonomy of the individual to the point where it is the receiver who creates meaning. Confidence in rationality is gone and the metanarrative (the big picture of a unified reality) is rejected. Modernism’s claim to objectivity is rejected. The author and the text cease to be the creators of meaning and it is left to the reader to create the meaning in the text.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Alternative presuppositional stances in theological study")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Theologians have suggested three main historical positions in theological ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("study and, therefore, in the understanding of the Bible.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN23",
      "id": "ap_NFIN23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The study of apologetics, the rational defence of the Christian faith, is useful for showing up the presuppositions that theologians use. Thus Bernard Ramm highlights the emphasis on subjectivism, or empiricism, or revelation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN24",
      "id": "ap_NFIN24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" The three positions are exemplified by the following figures.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("(i) Tertullian (born c. 160), who wrote at the beginning of the third century, was sceptical about the use of philosophical reasoning. ‘I believe what is absurd’ is said to characterize his approach."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN25",
      "id": "ap_NFIN25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" As Avery Dulles notes, ‘He wishes to bring out the distinctiveness of faith as it towers above all human reasoning and leaves man’s intellect prostrate in adoration before the unfathomable mystery of God.’"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN26",
      "id": "ap_NFIN26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" It is in essence the rejection of pure rationality in assessing objective realities. Tertullian anticipates existentialism, which focuses on selfunderstanding and plays down the importance of objectivity. Fideism is similar in its subjectivity and involves a ‘leap of faith’ approach to reality. It leaves little place for rationality or evidences in assessing truth.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("(ii) Thomas Aquinas (1225–74) represents the position, ‘I understand in order to believe.’ Human rationality assesses the evidences upon which faith is based. This leads to natural theology, empiricism and evidentialism. Thomas Aquinas ‘baptized’ Aristotelian empiricism and accepted that rational thought and empirical evidences provide the framework within which revelation is to be understood. Evidentialism is an apologetic approach that places great importance on historical and empirical evidences for the establishment of the truth."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN27",
      "id": "ap_NFIN27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Like Thomism, it assumes some common neutral ground upon which believers and unbelievers can agree about ultimate reality.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("(iii) Augustine (354–430) is, according to Carl Henry, characterized by the phrase ‘I believe in order to understand.’ This recognition of the interpretative "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("lordship of the Creator characterizes presuppositionalism in Christian theism. This is the consistent epistemological position of Reformed Christianity, although many evangelicals repudiate it. Presuppositionalism, unlike fideism, does not dispense with evidences and, we should note, evidentialism does not dispense with presuppositions. The point at issue is not presuppositions and evidences, but rather what constitutes a sound and consistent set of presuppositions and, consequently, by what criteria we can judge evidences.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("These three positions are useful for our purposes to illustrate basic stances with regard to how our humanity relates to God in the matter of truth and understanding. It is thus not my purpose to critically examine the positions of the three theologians mentioned. Nor will I ask whether or not these men would really own these slogans and the apparent logical extensions of them, or were consistent with them in their theologizing. What is important for us is that these three basic stances help us to get to the heart of the presuppositional choices facing the evangelical interpreter. The first (Tertullian) expresses the virtual eradication of human reason as having any authority. The second (Thomas Aquinas) indicates the subordination of divine revelation to an epistemological framework established by autonomous human reason that assesses empirical evidences. The third (Augustine) expresses the importance of human reason and understanding, but only as they are subordinated to divine truth and revelation.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("In both apologetics and hermeneutics we have at some point to deal with the universality of presuppositions and the significance of different presuppositional starting points. Then we must try to show why the presuppositions of Christian theism are more sustainable than those of the non-Christian as the basis for understanding truth. Non-Christian presuppositions must be shown to be self-referentially incoherent — that is, as failing to meet their own requirements for distinguishing the truth. This is essentially the method of the Reformed presuppositional apologetics expounded by Cornelius Van Til and largely adopted by Francis Schaeffer and John Frame.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN28",
      "id": "ap_NFIN28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Although we may classify various presuppositional stances in the way we have, the matter is by no means simple. Anthony Thiselton acknowledges this in his treatment of "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("horizons of understanding or expectation.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN29",
      "id": "ap_NFIN29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" The main difference between these terms and the more general idea of presupposition is the recognition of their impermanence and potential to be transformed. Presuppositions, on the other hand, ‘can only be changed and revised with pain or at least with diffculty’."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN30",
      "id": "ap_NFIN30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("The unavoidability of presuppositions")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Can there ever be neutral objectivity? Can we ever observe, reason and make judgments about objects and events without taking into account ourselves and our whole pre-existing mental baggage? Many scholars, particularly those following the thinking of the Enlightenment, seem to have assumed so, though one wonders if they really did think such a thing possible. If we take our basic dimensions of communication — sender, message and receiver — we soon see that what we understand each of these to be is really important for the way we perceive the viability of communication. If the sender is a humpback whale, the message a series of subsonic emissions and the receiver a deaf man paddling in the surf, there probably will be no communication. Even if the message is sonic and the receiver a human scientist equipped with a hydrophone, the sound may be picked up, but will any message be received?")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Thus in dealing with the biblical text, the assumptions we make about the sender, both divine and human, about the nature of the message as part of the Bible and about us will all be relevant to the interpretation of the text. These assumptions either directly or indirectly deal with the question of God. We assume that either he is or he is not the sender of the message. We assume that the text of the Bible is a word from God or it is not. We assume that we as receivers are subject to God and created in his image or we are not. A. B. Mickelsen, in his enquiry into the source of the interpreter’s principles, expresses the significance of our assumptions about God thus:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("There is no neutral ground in this controversy. If God did break through into history as the Bible records, then he is not only active in history, but he acts freely and purposefully above and beyond history."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN31",
      "id": "ap_NFIN31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Many scholars would say that this supposition of God in history involves a pretty big ‘if ’. Thus Ernst Troeltsch crystallized the historical-critical method in principles that were grounded on wholly different presuppositions.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN32",
      "id": "ap_NFIN32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" For him the universe is a closed system of cause and effect, and consequently there can be no such thing as divine intervention — such as miracles — and certainly no word-revelation from God. With that key assumption alone he ruled out the whole supernatural realm of which the Bible speaks. Miracles do not happen in a closed universe, so events like the resurrection clearly cannot happen. Troeltsch was, of course, giving expression to the assumption that the only truth is empirical truth, that which is discoverable by our senses. This is the non-empirical assumption that cannot be demonstrated empirically and therefore by its own standards cannot be affirmed. At best it can only be a possibility that is yet to be proved when "), _c('i', [_vm._v("all ")]), _vm._v("the data of "), _c('i', [_vm._v("all ")]), _vm._v("reality are in. It implies an exhaustive knowledge that it knows it does not have.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("To summarize, taking the approach to communication that is set out in the previous chapter, evangelicals make assumptions about each element involved:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("the sender/author: the God and Father of our Lord Jesus Christ;")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("the message: Scripture as the reliable word of God;")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("the receiver: human beings created in the image of God.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These assumptions or presuppositions are bound up with one another. If we accept that the Bible is God’s word, then he is the sender by whatever human medium. The receivers can be differentiated as original receivers — human authors used by God to speak and write his word; modern receivers — people of God/believers; unbelievers; and inconsistent believers who accept some of the presuppositions of unbelievers. In each case we are making assumptions in the realm of ontology, which deals with what things are in themselves."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN33",
      "id": "ap_NFIN33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Part of this ontology concerns epistemology, which focuses on us as knowing beings.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Basic evangelical presuppositions")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("An examination of some evangelical introductory texts on hermeneutics might suggest that evangelical hermeneutical method produces an uncertain sound. Where should an evangelical begin in the business of formulating valid principles of hermeneutics? It is interesting to note how some evangelical texts have been organized, what is included and, more to the point, what has not been included. In some of the titles footnoted")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN34",
      "id": "ap_NFIN34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" there is an apparent tendency, though not uniform, to concentrate on the history of hermeneutics and the literary dimensions of the biblical text. Berkhof gives a theological introduction in traditional terms of the nature of the Bible. McCartney and Clayton begin with a discussion of presuppositions. Mickelsen’s introductory section on principles contains little theology. It is understandable that evangelicals will tend to write such books with a view to apologetic needs, but this can tend to be reactionary. Thus, in the face of postmodernism, Millard Erickson proposes a new paradigm for a postmodern evangelical hermeneutic."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN35",
      "id": "ap_NFIN35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" My response to his proposal is that perhaps we also need to reaffirm a biblical hermeneutic.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("It is unlikely that Christians in general begin their spiritual journey by laboriously working through their basic assumptions and beliefs until some coherent structure is reached. But, however we arrive at it, the belief system that forms the assumptions we make as we read the Bible is a system that is always open to adjustments and fine-tuning as we understand more and more of the teaching of the Bible. We may indulge in nostalgic reflection on our experience of coming to faith, but in the end we are thrown back to the biblical analysis of everything involved. If we neglect to search the Scriptures for the truths relating to our conversion, we easily end up with an experience-based account that may be quite erratic and erroneous. Thus evangelical presuppositions may start with basic assumptions about the existence of God and the reality of an objective world that we are in touch with by our senses. In the apologetics of pre-evangelism we may try to lead someone through such basic beliefs. But as evangelical readers "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("of the Bible we have arrived at a belief structure that we accept as valid, though we are always open to some adjustments in the light of Scripture.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("Evangelicals repudiate the notion that the Bible is merely a human document. We thus reject at least some of the presuppositions of those who do regard the Bible in this humanistic way. This is not, of course, to reject the human dimensions of the Bible in its human authorship, its use of human language, and the human cultural and historical contexts of the various documents. In the previous chapter we looked at the dimensions involved in the consideration of the basic assumption that the Bible really is the divinely inspired word of God, written down by the agency of human authors, conveying in a variety of literary genres the revelation of God to human hearers and readers. This is not the place to try to defend this set of assumptions, but rather to state them, recognize them and enquire into their implications. The defence of them will come about both directly and indirectly as we build a picture of how these assumptions or presuppositions function.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("Modern evangelicals are usually fairly comfortable with the notion that their position is not novel but has roots in the Protestant Reformation of the sixteenth century. This, in turn, implies identification with the Reformers’ claim to be recovering the pure doctrines of the apostolic gospel. In the course of the Reformation the four ‘alones’ emerge that express the heart of the matter theologically: "), _c('i', [_vm._v("grace alone")]), _vm._v(", "), _c('i', [_vm._v("Christ alone")]), _vm._v(", "), _c('i', [_vm._v("Scripture alone ")]), _vm._v("and "), _c('i', [_vm._v("faith alone")]), _vm._v(". The question then arises as to how there can be four ‘alones’ that relate. A further question for this study is, in what way do the ‘alones’ help us understand the heart of evangelical hermeneutics?")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("In the historical context of the Reformation, each one of the ‘alones’ is both a positive assertion of a key theological principle and the definite rejection of a perceived theological error of the medieval Catholic Church. While the focus of each may be distinguished, they all represent a certain perspective on the biblical way of salvation. There can be four ‘alones’ because they are distinct emphases on the one essential truth of the gospel. Because there are four of them (some would add a fifth: "), _c('i', [_vm._v("the glory of God alone")]), _vm._v("), the question of priority arises. Is there logically a priority that must be given to one of these dimensions, a priority among equals, that in no way compromises the others?")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN36",
      "id": "ap_NFIN36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Modern hermeneutical enquiry has done much to formalize, categorize and analyse the issues that relate to reading and understanding the Bible. A brief "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("survey of the history of biblical interpretation, however, reveals that many of the issues of modern hermeneutics have been discussed and studied from the earliest times of Christian exposition of Scripture. Since evangelical theology stands firmly on the shoulders of the Reformation, we might enquire how some of these modern hermeneutical concerns were expressed then. One of the most important areas to investigate, in my opinion, involves the theological foundations of evangelical biblical interpretation. Let us, then, examine some of the implications of the characteristic ‘alones’.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Grace alone")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('i', [_vm._v("Grace alone ")]), _vm._v("is understood first of all in relation to the way salvation comes to us, and how we receive it. It is a principle that applies the notion of grace as the totally unmerited gift of God, whereby he acts for the good of those who deserve only his condemnation. It therefore rules out any sense that we can merit our salvation or contribute to it. Christ died for us while we were still helpless sinners. "), _c('i', [_vm._v("Grace alone ")]), _vm._v("stems from the reality of creation and the fall of the human race. The narrative of Genesis 1 – 3 leaves room only for a total end there and then, or for the grace of God to operate in the whole process that leads eventually to the new creation and the glorious kingdom of God. The mediator of the process is ultimately and exclusively Jesus Christ. All of this happens because God is who he is. The nature and attributes of God are either a fiction, or they are essential to our being, knowing and interpretation of any communication. Grace is a doctrinal way of saying something about the essential being of God: what he is and what characteristics of his being he reveals. Grace speaks of the priority of God’s being as the source of all things and the measure of all things. In philosophical terms this is a matter of ontology. That God shows grace also demonstrates that the recipients are in need of it. "), _c('i', [_vm._v("Grace alone ")]), _vm._v("was thus the Reformation repudiation of the Roman Catholic notion of nature plus grace.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN37",
      "id": "ap_NFIN37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("The principle of ‘grace alone’ points us to the ontological priority of God")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Christ alone")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Christ alone ")]), _vm._v("means that salvation is found nowhere else but in the person and "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("work of Jesus Christ. This exclusivist conviction is based on the evidence of Scripture. Such evidence includes the specifically exclusivist claims concerning Jesus, and also the coherence of the biblical story. This story tells of events from creation to new creation in a narrative that takes us through the fall, the call of Abraham, the redemption of Israel, the fortunes of the nation and the prophetic promises and expectations for the fulfilment of the original covenant promises. At the climax of the story is the event of the incarnation of the Christ, his life, death, resurrection and ascension to glory. The purposes of God in this story are expressed in such a way as to show that the destiny of all the peoples of the world and of the whole universe is tied to the work of God in Christ. The cross of Christ is the redemptive event that has ramifications for the redemption of the whole created order.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("If the biblical story is true, Christ is the only saviour for humankind and there is room for no other way to God. If the story is true, Jesus Christ is the interpretative key to every fact in the universe and, of course, the Bible is one such fact. He is thus the hermeneutic principle that applies first to the Bible as the ground for understanding, and also to the whole of reality. Interpreting reality correctly is a by-product of salvation. Thus we must assert that the person and work of Jesus Christ are foundational for evangelical hermeneutics. As we shall examine in more detail, Christ interprets all facts, since all things were created in him, through him and for him (Col. 1:16). As the one mediator between God and man (1 Tim. 2:5), Christ mediates the ultimate truth of God about all things and thus about the meaning of the Bible.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('i', [_vm._v("The principle of ‘Christ alone’ points us to the soteriological and hermeneutical priority of the gospel of Christ")]), _vm._v(".")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-014"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Scripture alone")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Nothing exists except by the decree of God. We know this fact, and we know God, only because he has revealed himself through his Son, Jesus Christ. Furthermore, we know this fact, and we know Jesus Christ, only because he is revealed to us in Scripture. When the Reformers enunciated the principle of "), _c('i', [_vm._v("Scripture alone ")]), _vm._v("they asserted that there is no other source of truth available to us by which we can know Christ and, through him, God. Negatively, they repudiated the notion of a living tradition of the church as a separate source of truth that enjoys a similar authority to that of the Bible. They were not repudiating the role of tradition as such, but only seeking to subordinate it to the final authority of Scripture. It was not tradition that was the concern, ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("but tradition that contradicted Scripture.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN38",
      "id": "ap_NFIN38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" They rejected the doctrine of a teaching magisterium that alone could provide the true interpretation of Scripture. Instead of the Roman Catholic assertion that, since the church gave us the Bible, the church alone could interpret the Bible, the Reformers rightly said that God, by his word, creates the church, which must therefore submit to biblical authority. For the ordinary Christian "), _c('i', [_vm._v("Scripture alone ")]), _vm._v("simply means that we must read the Bible or hear the message of the Bible if we are to know God. The relationship of the God of the Bible to the whole of reality is such that no empirical facts are ultimately understood until they are understood as facts of the Creator. To know God and his creation, we have to take account of the nature of Scripture and of the phenomena that present themselves in Scripture. Hermeneutics is concerned with the practical application of "), _c('i', [_vm._v("Scripture alone")]), _vm._v(".")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("The principle of ‘Scripture alone’ points us to the phenomenological and material priority of Scripture")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Faith alone")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Faith alone ")]), _vm._v("was the implication that Luther saw in the biblical teaching that ‘the righteous shall live by faith’ (Rom. 1:17, quoting Hab. 2:4). It is the truth expressed by Paul in Ephesians 2:8–9 that no human effort or good work can contribute to our salvation. Negatively, "), _c('i', [_vm._v("faith alone ")]), _vm._v("was a rejection of the whole Roman Catholic system of merits. It was a reversal of the upside-down gospel of Rome that put our subjective sanctification as the basis of justification. This had in effect opened the door to our works of sanctification being made the grounds of salvation. But the question of faith also raises several vital questions — for example, what is faith and how do we come to have it? The simple answer is that faith is a gift of God’s grace. It is an attitude, born in us by the Holy Spirit, of trust in the promises of God relating to the efficacy of Christ’s life, death and resurrection on our behalf. It is a gift in that we cannot, by our unaided will, exercise it. Yet it is a subjective thing, for we do exercise it and are fully conscious of doing so. The Bible says much about unbelief or lack of faith. It also says and implies much about the bondage of the human will when in rebellion against God. It thus "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("points to two things with regard to faith: the inability of the sinner, and the need for the regeneration of the Holy Spirit if the sinner is to be made able to have faith. Faith is always defined by its object: the person and work of Christ.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('i', [_vm._v("The principle of ‘faith alone’ points us to the ontological inability of the sinner and the epistemological priority of the Holy Spirit")]), _vm._v(".")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-016"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("The four ‘alones’ and the Trinity")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("In outlining these four ‘alones’ of the Reformation I have tried to demonstrate that the consideration of presuppositions, which we may now investigate in more philosophical terms, were at the heart of Reformation theology and understanding of the Bible. We do not seek to subvert "), _c('i', [_vm._v("Scripture alone ")]), _vm._v("by slavishly following a tradition handed down from the Reformers. But we do not want to reinvent the wheel and so are not afraid (to mix the metaphors) to climb on the shoulders of the great ones who have gone before us.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("It is important to grasp that the four ‘alones’ really take their essential characteristics from God as Trinity. Consequently, none of the ‘alones’ can exist without the others. Nor can the evangelical assumption that the Bible is the word of God remain at the level of undefined generality. What kind of God speaks his word to us? How does he reveal himself to us? If we answer that he is the God of the gospel, we only point to the need to deepen our understanding of the gospel beyond the level of superficiality to take account of what the Bible reveals the gospel to be. The gospel of our salvation through faith alone, in Christ alone, by grace alone, as revealed in the Bible alone, is what it is only because God is the kind of God he is. Those groups who claim to be Christian while rejecting the historic Christian faith in the divine and human natures of Christ, and in the Trinity, usually end up with a gospel that is denuded of grace and that amounts to salvation by faith in a diminished Christ who is then augmented by our works of obedience. It would not be an exaggeration to say that ‘grace alone’ is unique to biblical Christianity.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("Because these dimensions stem from the ontological nature of God as Trinity, we can see that their relationships are derivative of the relationships within the Trinity. The doctrine of the Trinity is essentially ontological, not manifestational (economic). That is, the three-ness of the unity of God is not just a way of talking about three different roles that the one God assumes: ")]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("Creator, Saviour and Indweller.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN39",
      "id": "ap_NFIN39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" We recognize that the Bible presents different kinds of clues to this nature of God, not least of which is the incarnation. If Jesus is God and yet speaks about God the Father and the Spirit of God in the third person, he is clearly mistaken, or else God "), _c('i', [_vm._v("is ")]), _vm._v("Trinity. But because God is also perfect unity, it is impossible to consider any one person of the Trinity without also considering the other two. The other side of that coin is that the three persons are not interchangeable in their functions. The Father sends the Son, the Son suffers and dies, the Father and the Son send the Holy Spirit among the people of God, and so on. Another way of stating this co-dependence of the persons of the Trinity is to say that there is unity of the persons without fusion; there is distinction without separation.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The kind of God we presuppose to be in control of creation and salvation is Trinity. If the world had been made by a different kind of God, for example the undifferentiated Allah of Islam, or the monistic God of modern Judaism,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN40",
      "id": "ap_NFIN40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Watchtower (Jehovah’s Witnesses) or Christadelphianism, of necessity it would be a different kind of world. It is significant that each of these non-Trinitarian religions has its own particular doctrine of salvation by works.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("To summarize, the basic evangelical presuppositions are those that relate to the existence, not of a god or divine being, but of the God and Father of our Lord Jesus Christ. Since he is the Creator and Lord of all things, then this basic presupposition affects the way we think about every other fact available to us. The basic presupposition is thus an ontological one concerning the being of God that establishes the ontology of the universe and every creature in it. This then leads us to derivative presuppositions that will be expressed largely in terms of dogmatics or systematic theology. There is a hierarchy of presuppositions in that we do not start every new theological or hermeneutical endeavour by going back to the absolute basics. We will come each time to the biblical text with an "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("already formed and, for some, elaborate theological framework. As we build our systematic theology as an interpretative presupposition it is important that it does not become set in concrete. Doctrinal confessions or subordinate authorities must not become ultimate authorities. Thus, although we do not reestablish our basic assumptions every time we come to the text, it is still an ongoing concern that we constantly check them to see that they are true to Scripture. The hermeneutical spiral is always present in the interpretation of Scripture. This spiral is the ongoing process that seeks to maintain the integrity of our method.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-017"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("The function of evangelical doctrine")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("As Carl Henry states:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Each world view has its distinctive starting point or touchstone thesis through which it attempts to unify and explain human experience. The Christian philosopher is under no intellectual compulsion, therefore, to accept rival premises, however fashionable, as the starting point for advancing his or her theistic world view.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN41",
      "id": "ap_NFIN41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Francis Schaeffer makes this observation:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("Many people catch the presuppositions like some children catch measles. They have no idea where they come from. But that is not the way the thinker chooses his presuppositions. His presuppositions are selected on the basis of which presuppositions fit what is; that is, what presuppositions give solid answers concerning what is. It is only the Christian presuppositions which explain what is — in regard to the universe and in regard to man."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN42",
      "id": "ap_NFIN42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The non-Christian’s axioms are just as much assumed as are the Christian’s. Let the reader understand! We do not have to allow the Enlightenment agenda to determine ours. Only in a relative way can it be permitted to dictate our concerns as we try to understand modernism and postmodernism and determine our response to them. We may test all presuppositions for explanatory power and logical consistency. Tests of rational consistency are important. "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v(" Presuppositions about God include the fact that he is a rational being who has created us in his image as rational beings. This rationality is never to be confused with philosophical rationalism, however much they may overlap.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("Presuppositions will decisively influence the interpretation of data. Christian theism affirms God in his revelation as the basis of experience. If the biblical picture is true, then this is the only way it can be. Thus we reckon on Christian theistic presuppositions because they are consistent with what the Bible says about God, sin, our world and us. What is more, they lead to a coherent view of reality that is capable of explaining our experience of reality. We believe that we can live, and account for our experience, consistently with our presuppositions in a way that non-theistic systems cannot. Basic Christian doctrine, then, becomes the presupposed basis for the evangelical interpretation of Scripture. This raises again the question of how we arrive at this doctrine, if not by interpreting the Scriptures. Only some kind of hermeneutical spiral can cope with this circularity. The derived presuppositions of Christian theism will include the following.")])]), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("• God has revealed himself as rational, and as communicator, as well as sovereign Lord and Creator.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("• Human beings are rational receivers of God’s communication, because that is how he has made us.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v(" Sin consists in, among other things, a wilful refusal of truth and the substitution of human reason as autonomous in the place of God’s self-attesting revelation.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN43",
      "id": "ap_NFIN43-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("• Redemptive revelation and the work of the Holy Spirit are necessary to restore humans to a state where they can receive ultimate, but not exhaustive, truth.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("• The mediatorial role of Jesus of Nazareth is the guarantee of real communication between God and people. The gospel of Jesus Christ reveals him as the Word of God who is the truth. Jesus as the divine communicator, the saving message and the human receiver demonstrates where the heart of true hermeneutics lies. The gospel is the power of God for salvation, which includes hermeneutical salvation.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("These points involve us in a theology of the Word that is inseparable from the big picture of Christian theism. A biblical theology of the Word of God and of interpretation will be our concern in chapter 4. For the moment, however, let us note the contrast between the two presuppositional stances of Christian theism and humanism. The one asserts the impossibility of knowledge of the truth apart from the source of truth, which is God. The other places autonomous human reason above the claims of the Creator to be the source and the communicator of truth. The implication of theism for hermeneutics is that we must resist all attempts to remove the sovereignty of the Creator-Word from our thinking about meaning and communication. Consistent evangelical hermeneutics must begin with God as he has revealed himself in Jesus Christ.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("A case must be established for the essentially Christological nature of authentic hermeneutics, biblical and general. We assume either that God is there and that he has communicated with us, or that there is no one there and thus no communication has come from without. If we assume the former, then we must allow that the transcendent and sovereign God has made the ground rules for the communication. What, then, are those ground rules?")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-018"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Ontology")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("We have considered something of the importance of understanding the Trinity both in economic and ontological terms. We make ontological assumptions about the kind of God who has spoken, about the kind of word he speaks, and about the kind of people we are who receive the word. Every Christian builds up a concept of God over time through reading the Bible, hearing sermons and talking to other Christians. In doing this we will be somewhere on a continuum between inconsistency and consistency with the four ‘alones’. An evangelical tries to be biblical and thus to be as consistent as possible with these biblical dimensions. One way of stating this is that we begin with a basic assumption about the existence of God. We further assume that this God is behind the form and the content of the Bible. As we read the Bible we build on our understanding of God, while at the same time eliminating previously held misunderstandings or erroneously formed concepts of God. This in turn affects the way we conceive of the Bible and of ourselves as the readers of the Bible.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("By this process we develop, by whatever name, a doctrine of God and his word. Because we are not isolated from our Christian peers, or from those who have gone before, we can build an understanding that is to a greater or lesser degree dependent on the community of understanding in the Christian church ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("that spans the centuries. Some, unfortunately, will care little for this process and will be content to live with an immature understanding and a stunted faith. Others will be attracted to Christian communities that major on ‘experience’ and on being ‘Spirit-driven’. They will develop a hermeneutic that understands the Bible in the light of experience rather than interpreting experience by the Bible. When we speak of the ontological priority of God, we mean that nothing exists except for the prior existence of God who is the Creator of all things. Once we accept that principle, it is impossible simply to shove it away in a pigeonhole for safe keeping. Its ramifications cover everything else that exists and everything that happens. This, of course, includes the Bible and all that it speaks about, including us as God’s creatures. It means that the ontological considerations of everything that is not God must include the property of being created by God and, thus, being interpreted by him.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-019"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Epistemology")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("After ontology, the philosophical category that most affects our pursuit for understanding is epistemology. This concerns the questions of what we know and how we know that we know it. At a common-sense level we assume that there is some real link between what we perceive with our senses and what is really there. The philosophical discussions about epistemology began in earnest with the ancient Greeks.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN44",
      "id": "ap_NFIN44-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" It may suffice as a common-sense Christian approach to say that God made and knows all things, and he has made us in his image to know things truly, if not exhaustively. We shall pursue this line in chapter 4. As we try to pin down a biblical epistemology, we should at the same time be aware of the challenges to any such thing from modern hermeneutical theory. Modernism in the scientific age moved beyond Kant to express the ultimate confidence in objectivity that is philosophically neutral. Postmodernism has swung to the other extreme in subjectivity. Yet both are "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("expressions of a view of human autonomy and complete independence of any God or gods.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("The biblical view of things provides us with a perspective that values both objectivity and subjectivity together. At its most basic level, it is summed up in the view that the God of the Bible made us in his image as reasoning, perceiving and responsible beings. God thus addresses us as responsible beings who have some contact with reality, even when our repudiation of our nature as being made in God’s image renders our perceptions faulty and even fatal. Thus Christian theism involves us in an epistemology that accepts the following biblical notions:")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("the exhaustive and infallible knowledge that God has of all things;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("the creation of human beings to be able to truly know God and his creation;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("the fallenness of our thinking and reasoning so that truth is suppressed;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("the redemptive renewing of our minds through the gospel of Christ;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("the redemptive revelation of God’s truth as objective reality;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("the regeneration by the Spirit enabling subjective apprehension of God’s truth.")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-020"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Christology and hermeneutics")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("How can we unpack the notion that the gospel is the power of God for hermeneutical salvation? What are the hermeneutics of Christ?")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen9#NFIN45",
      "id": "ap_NFIN45-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" The question might be stated as the relationship of the three major dimensions of communication to Jesus Christ. According to the gospel the real link between the communicator, the message and the receivers is the incarnated God/Man, thus:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("Jesus is God, the infallible communicator;")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("Jesus is the Word, the infallible message;")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("Jesus is the God/Man, the infallible receiver.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We can go further than this to assert, on the basis of the gospel, that because Jesus is the ideal and true receiver of the word of God, he is also the true and faithful human responder to the word and proclaimer of that word. "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("According to the gospel, everything he is in his perfect humanity, he is on our behalf as our representative and substitute. He justifies us as receivers and responders to the word of God. Our hermeneutical endeavour is ideally the sanctificational process that is the fruit of our Saviour’s perfect hermeneutics and response to the word of God. It will be this only if our hermeneutics is gospel-centred. In what follows I aim to work through some of the implications of a gospel-centred approach.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098def88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap3.vue
// module id = 81
// module chunks = 0